module.exports = __webpack_public_path__ + "static/media/jasmine-icon.1c9af273.png";